import { forwardRef, useEffect, useImperativeHandle, useRef, useState, type VideoHTMLAttributes } from 'react'
import { cn } from '#app/utils/tailwind-merge'

export type VideoProps = VideoHTMLAttributes<HTMLVideoElement> & {
	src: string
	width: string
}
/* The video element */
const Video = forwardRef<HTMLVideoElement, VideoProps>(({ src, width, height, className, ...props }, ref) => {
	const [state, setState] = useState<'loading' | 'ready' | 'failed'>('loading')
	const videoRef = useRef<HTMLVideoElement | null>(null)
	useImperativeHandle<HTMLVideoElement | null, HTMLVideoElement | null>(ref, () => videoRef.current) // Merge the two refs

	useEffect(() => {
		if (videoRef.current) {
			if (videoRef.current.networkState === HTMLMediaElement.NETWORK_NO_SOURCE || videoRef.current.error) {
				onError()
			}
		}
	}, [videoRef])

	const onReady = () => {
		setState('ready')
	}
	const onError = () => {
		setState('failed')
	}

	return (
		<video
			ref={videoRef}
			src={src}
			width={width}
			height={height}
			onCanPlay={onReady}
			onError={onError}
			data-loading={state === 'loading' || undefined}
			data-ready={state === 'ready' || undefined}
			data-failed={state === 'failed' || undefined}
			{...props}
			className={cn('video', className)}
		/>
	)
})
Video.displayName = 'Video'
export { Video }
